import React from "react";
import { cn } from "../../lib/utils";

export const ImageOverlay = ({
  image,
  children,
  src,
  alt,
  className,
  ...props
}) => {
  return (
    <div className={cn("relative rounded-2xl overflow-hidden", className)} {...props}>
      <img src={src} alt={alt} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent p-2 lg:p-4 flex flex-col justify-end">
        {children}
      </div>
    </div>
  );
};
